query DaDataSuggestOrganization($query: String!, $count: Int = 10) {
  dadataSuggestOrganization(query: $query, count: $count) {
    suggestions {
      value
      unrestricted_value
      data {
        inn
        kpp
        ogrn
        name {
          full_with_opf
          short_with_opf
          full
          short
        }
        address {
          value
          unrestricted_value
        }
        management {
          name
          post
        }
        state {
          status
        }
      }
    }
  }
}
